import { MapPin, Phone, Mail, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="teal-gradient-bg text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            {/* Family Shoe Store Logo */}
            <div className="mb-6 bg-white p-4 rounded-lg inline-block">
              <img 
                src="/logo.png"
                alt="Family Shoe Store Logo" 
                className="h-16 md:h-24 w-auto block"
                data-testid="footer-logo"
                loading="eager"
              />
            </div>
            
            {/* LinkedIn Link */}
            <a 
              href="https://www.linkedin.com/company/family-shoe-shop-premium/" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-80 transition-opacity mb-4"
              data-testid="linkedin-link"
            >
              <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg border border-white/20 hover:bg-white/20 transition-all">
                <div className="w-12 h-12 bg-[#0077B5] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Linkedin className="w-7 h-7 text-white" />
                </div>
                <div>
                  <p className="text-white font-bold text-lg">Follow Us</p>
                  <p className="text-white/70 text-xs">Connect on LinkedIn</p>
                </div>
              </div>
            </a>
            
            {/* Store Description */}
            <p className="text-white/80 leading-relaxed text-sm">
              Soft, comfy, and unique shoes for the whole family that will keep you moving!
            </p>
          </div>

          <div>
            <h4 className="text-lg font-heading font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/shop" className="text-white/80 hover:text-white hover:underline transition-all cursor-pointer" data-testid="footer-shop-link">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/team" className="text-white/80 hover:text-white hover:underline transition-all cursor-pointer" data-testid="footer-team-link">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white hover:underline transition-all cursor-pointer" data-testid="footer-contact-link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-heading font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <a 
                href="https://www.google.com/maps/search/?api=1&query=Corbin,+KY" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-start hover:text-white transition-colors cursor-pointer"
                data-testid="footer-address"
              >
                <MapPin className="w-5 h-5 mr-3 mt-1 flex-shrink-0" />
                <span className="text-white/80 hover:text-white">
                  Corbin, KY
                </span>
              </a>
              <a 
                href="tel:+15025550123"
                className="flex items-center hover:text-white transition-colors cursor-pointer"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 mr-3" />
                <span className="text-white/80 hover:text-white">(502) 555-0123</span>
              </a>
              <a 
                href="mailto:info@familyshoeshop.com"
                className="flex items-center hover:text-white transition-colors cursor-pointer"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 mr-3" />
                <span className="text-white/80 hover:text-white">info@familyshoeshop.com</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} Family Shoe Shop. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;